import type { StrictOmit } from "ts-essentials";
import { z } from "zod";
import type { SchemaShape, TableSchemaShape } from "~/components/Form";
import type {
  ListUsersRequest,
  UserCreateRequest,
  UserUpdateRequest,
} from "~/dsm";
import { commonResourceFilterSchemas } from "../../filters";
import {
  boolean,
  filterBoolean,
  filterText,
  filterUuid,
  optionalText,
  optionalUuid,
  requiredText,
} from "../../schemas";

export const listUsersSchema = z.object({
  username: filterText,
  usernameLike: filterText,
  roleId: filterUuid,
  admin: filterBoolean,
  managed: filterBoolean,
  disabled: filterBoolean,
  ...commonResourceFilterSchemas,
} satisfies TableSchemaShape<ListUsersRequest>);

export const createUserSchema = z.object({
  username: requiredText,
  roleId: optionalUuid,
  admin: boolean,
  managed: boolean,
  disabled: boolean,
  externalId: optionalText,
} satisfies SchemaShape<StrictOmit<UserCreateRequest, "password">>);

export const editUserSchema = z.object({
  username: requiredText,
  roleId: optionalUuid,
  admin: boolean,
  disabled: boolean,
  externalId: optionalText,
} satisfies SchemaShape<StrictOmit<UserUpdateRequest, "password">>);
